import React, {  useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AllEmployees from "components/AllEmployees";
import AllDepartments from "components/AllDepartments";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


export default function TabComponent() {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="All" {...a11yProps(0)} sx={{ textTransform: "none", fontWeight: 800 }} />
          <Tab
            label="Departments"
            {...a11yProps(1)}
            sx={{ textTransform: "none", fontWeight: 800 }}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <AllEmployees />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AllDepartments />
      </CustomTabPanel>
    </Box>
  );
}
